var map = {
	"./custom/app/header-nav-wrapper/header-navbar-wrapper.component": [
		66520,
		"src_themes_custom_app_header-nav-wrapper_header-navbar-wrapper_component_ts"
	],
	"./dspace/app/header-nav-wrapper/header-navbar-wrapper.component": [
		47435
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 20991;
module.exports = webpackAsyncContext;